<template>
  <div class="content-box">
    <div aria-labelledby="exampleModalLabel" class="modal fade" id="exampleModal1" role="dialog" tabindex="-1"
      aria-hidden="true" style="display: none">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">Nueva Recepción</h5>
            <button aria-label="Close" class="close" data-dismiss="modal" type="button">
              <span aria-hidden="true"> x </span>
            </button>
          </div>
          <form @submit="crearRecepcion">
            <div class="modal-body">
              <div class="form-group">
                <label v-bind:class="{
                  'text-danger':
                    nueva_recepcion.errors.tienda &&
                    nueva_recepcion.errors.tienda.length > 0,
                }">Tienda</label>
                <select class="form-control" autofocus="autofocus" @change="refreshRampas"
                  v-model="nueva_recepcion.tienda">
                  <option v-for="(c, key) in tiendas" :vanlue="c.codigo" :key="key">
                    {{ c.nombre }}
                  </option>
                </select>
                <small v-if="nueva_recepcion.errors && nueva_recepcion.errors.tienda" class="form-text text-danger">{{
                  nueva_recepcion.errors.tienda[0] }}</small>
              </div>
              <ProveedoresSelectComponent :current="nueva_recepcion" />
              <!-- <div class="form-group">
                <label
                  v-bind:class="{
                    'text-danger':
                      nueva_recepcion.errors.rampa &&
                      nueva_recepcion.errors.rampa.length > 0,
                  }"
                  >Rampa</label
                >
                <select class="form-control" v-model="nueva_recepcion.rampa">
                  <option v-for="(c, key) in rampas" :value="c.id" :key="key">{{
                    c.identificador
                  }}</option>
                </select>
                <small
                  v-if="nueva_recepcion.errors && nueva_recepcion.errors.rampa"
                  class="form-text text-danger"
                  >{{ nueva_recepcion.errors.rampa[0] }}</small
                >
              </div> -->
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary" type="submit">Crear Recepción <i class="fa fa-check-square"></i></button>
              <button class="btn btn-danger" data-dismiss="modal" type="button" ref="cerrarModalNuevaRecepcion">
                <i class="fas fa-times"></i>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <div class="element-wrapper">
      <div class="element-box">
        <h5 class="form-header">Recepciones</h5>
        <!-------------------- START - Controles arriba de tabla-------------------->
        <div class="controls-above-table">
          <div class="row">
            <div class="col-sm-12 col-md-3">
              <button class="btn btn-md btn-success" @click="ToAgenda()">
                Nueva Recepción &nbsp;<i class="fas fa-plus"></i>
              </button>
              <!--
              <button class="btn btn-md btn-success btn-block" data-target="#exampleModal1" data-toggle="modal"
                type="button">
                Nueva Recepción &nbsp;<i class="fas fa-plus"></i>
              </button>-->
              <br />
              <button v-if="dataTabla == null" type="button" data-toggle="modal" data-target="#modalTiendaSelect"
                class="btn btn-dark btn-block">
                Cargar Información <i class="fas fa-download"></i>
              </button>
            </div>
            <div v-if="dataTabla" class="col-sm-12 col-md-9">
              <div class="form-inline justify-content-sm-end">
                <select class="form-control form-control-sm rounded bright col-6" v-model="filterTienda"
                  @change="refreshData()">
                  <option v-for="(item, key) in tiendas" :value="item.codigo" :key="key">
                    {{ item.nombre }}
                  </option>
                </select>
                <select class="form-control form-control-sm rounded bright" v-model="filtro_estado"
                  @change="refreshData()">
                  <option value="A">Abierta</option>
                  <option value="B">Cerrado</option>
                  <option value="C">Finalizado</option>
                  <option value="9">Anulado</option>
                </select>
                <input class="form-control form-control-sm rounded bright" placeholder="Search" v-model="searchtext"
                  type="text" v-on:keyup.enter="refreshData()" />
                <div class="input-group-append">
                  <button class="btn btn-link btn-sm" type="button" v-on:click="refreshData()">
                    <i class="fa fa-search"></i>
                  </button>
                  <button class="btn btn-link btn-sm" type="button" v-on:click="clearFilterData()">
                    <i class="fa fa-times"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <RecepcionTableComponent :dataTabla="dataTabla" />
      <PaginationComponent v-if="dataTabla != null" :currentPage="currentPage" :data="dataTabla"
        @pagechanged="refreshData" />
    </div>
    <div class="modal fade" id="modalTiendaSelect" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle"
      aria-hidden="true" data-backdrop="static" data-keyboard="false">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLongTitle">Elije una tienda</h5>
          </div>
          <div class="modal-body">
            <select class="form-control col-12" v-model="filterTienda" @change="refreshData()">
              <option v-for="(item, key) in tiendas" :value="item.codigo" :key="key">
                {{ item.codigo }} - {{ item.nombre }}
              </option>
            </select>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">
              Cerrar <small> (No se mostrara información)</small>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import UsuarioEnTablaComponent from "@/components/commons/UsuarioEnTablaComponent";
import RecepcionTableComponent from "@/components/wms/recepcion/RecepcionTableComponent";
import ProveedoresSelectComponent from "@/components/commons/ProveedoresSelectComponent";
import DynamicService from "@/services/commons/DynamicService";
import PaginationComponent from "@/components/utils/PaginationComponent";
import Notifications from "@/notifications/notifications";
import TiendaSelectComponent from "@/components/commons/TiendaSelectComponent";

export default {
  components: {
    RecepcionTableComponent,
    UsuarioEnTablaComponent,
    ProveedoresSelectComponent,
    PaginationComponent,
    TiendaSelectComponent,
  },
  data() {
    return {
      dataTabla: null,
      filterTienda: "",
      mostrarRefresh: false,
      currentPage: 1,
      searchtext: "",
      filtro_estado: "A",
      rampas: [],
      nueva_recepcion: {
        tienda: null,
        proveedor: null,
        rampa: null,
        errors: {
          tienda: null,
          proveedor: null,
          rampa: null,
        },
      },
    };
  },
  computed: {
    ...mapGetters({
      tiendas: "catalogos/tiendas",
    }),
  },
  mounted() {
    this.$store.dispatch("catalogos/llenar_tiendas", {
      activa: true,
      quitar_paginacion: true,
    });
    this.refreshMyuserTienda();
  },
  methods: {
    refreshMyuserTienda() {
      let self = this;
      DynamicService.fetch("cat", "tienda-usuario", {
        myprofile: true,
      })
        .then((response) => {
          self.filterTienda = response.data.results[0].tienda.codigo;
          self.refreshData();
        })
        .catch((error) => {
          $("#modalTiendaSelect").modal("show");
        });
    },
    refreshData(page) {
      $("#modalTiendaSelect").modal("hide");
      if (page) {
        this.currentPage = page;
      }
      DynamicService.fetch("wms", "recepcion", {
        tienda: this.filterTienda,
        page: this.currentPage,
        "filter[search]": this.$data.searchtext,
        estado: this.filtro_estado,
      }).then((response) => {
        this.dataTabla = response.data;
      });
    },
    crearRecepcion(e) {
      let self = this;
      e.preventDefault();
      var current = Object.assign({}, self.nueva_recepcion);
      if (current.proveedor) {
        current.proveedor = current.proveedor.codigo;
      }
      DynamicService.save("wms", "recepcion", current)
        .then((res) => {
          self.$refs.cerrarModalNuevaRecepcion.click();
          Notifications.alert.success("Recepcion", "Se ha guardado la Información.");
          self.$router.push({
            name: "wms-recepcion-editar",
            params: { id: res.data.id },
          });
        })
        .catch((error) => {
          console.log(error);
          Vue.nextTick(function () {
            self.nueva_recepcion.errors = Object.assign({}, error.response.data);
          });
        });
    },
    ToAgenda() {
      let self = this;
      Notifications.alert.confirm(
        "¿Ir a Agenda?",
        "Debe crear primero un evento antes de recepcionar la mercadería.",
        "",
        function () {
          self.$router.push({
            name: "wms-agenda",
            params: {},
          });
        }
      );
    },
    refreshRampas() {
      let self = this;
      DynamicService.fetch("wms", "rampa", {
        quitar_paginacion: true,
        tienda: self.nueva_recepcion.tienda,
      }).then((response) => {
        self.rampas = response.data;
      });
    },
    clearFilterData() {
      this.$data.searchtext = "";
      this.$data.currentPage = 1;
      this.filterTienda = "";
      this.filtro_estado = "A";
      this.dataTabla = null;
      $("#modalTiendaSelect").modal("show");
    },
  },
};
</script>
